import { isEmpty, get } from 'lodash';
import { getUgcData } from '@fiverr-private/personalized_content';
import { machineTranslate } from '../machineTranslation';

export const translatePersonalizedContent = async ({ personalizedContent, targetLocale, sourceInfo }) => {
    const translatableContent = extractTranslatableContent(personalizedContent, targetLocale);

    if (!translatableContent) {
        return personalizedContent;
    }

    const translationResponse = await machineTranslate({
        text: translatableContent,
        targetLocale,
        sourceInfo,
    });

    return buildTranslatedPersonalizedContent(translationResponse, personalizedContent);
};

const isGigsComponent = (component) => !isEmpty(get(component, 'items.gigs', null));

const extractTranslatableContent = ({ sections = {} }, targetLocale) => {
    const translatableContent = {};

    Object.values(sections).forEach((componentsArr: any) => {
        componentsArr.forEach((component) => {
            if (isGigsComponent(component)) {
                const translatableGigsContent = getUgcData(component.items.gigs, targetLocale);

                Object.assign(translatableContent, translatableGigsContent);
            }
        });
    });

    return translatableContent;
};

const buildTranslatedPersonalizedContent = (translationResponse, personalizedContent) => {
    const { translatedBlob } = translationResponse;

    const buildTranslatedGig = (gig) => ({ ...gig, ...translatedBlob[gig.gig_id] });
    const buildTranslatedComponent = (component) => ({
        ...component,
        items: {
            ...component.items,
            gigs: component.items.gigs.map(buildTranslatedGig),
        },
    });

    const sectionsWithTranslatedGigs = Object.fromEntries(
        Object.entries(personalizedContent.sections).map(([sectionName, componentsArr]) => [
            sectionName,
            (componentsArr as any).map((component) =>
                !isGigsComponent(component) ? component : buildTranslatedComponent(component)
            ),
        ])
    );

    return { sections: sectionsWithTranslatedGigs };
};
